import React, { useState, useEffect, useRef } from "react";
import useStyles from "./styles";

import EmptyGrid from './../../assets/img/emptyGrid.svg';

export default function NoRecord({ message, iconSize, Icon, ...props }) {
    const classes = useStyles();
    return (
        <>
            <div className={classes.noRecord}>
                {Icon ? <img src={EmptyGrid} style={{width: iconSize? iconSize: ''}} /> : ''}
                <div className={classes.noRecordText}> {message} </div>
            </div>
        </>
    )
}
